import { useEffect, useState } from "react";

import FormComp from "../../Componentes/FormComp";
import Overlay from "../../Componentes/Overlay";
import Formulario from "../../Componentes/Utils/Formulario";
import Modal from "../../Componentes/Utils/Modal";
import { useModal } from "../../contexts/ModalContext";
import useApi from "../../hooks/useApi";
import { formatBRLFromCents, parseCentsFromInput } from "../../Funcoes/Money";

/**
 * Motivos disponíveis para lançamento manual na folha.
 *
 * Observação: VA OBRA / CARTÃO ALELO, VALE TRANSPORTE e DIARIA DE VIAGEM
 * foram removidos a pedido — esses valores entram por outra rotina
 * (benefícios TOTVS / tabela colaboradores).
 */
const MOTIVOS = [
    "ADC PF",
    "COMPRA FOLGA DE CAMPO",
    "DESCONTO DIVERSOS",
    "FOLGA DE DOMINGO",
    "PLR",
    "REEMBOLSO DE PASSAGENS",
    "REEMBOLSO DE V.A",
    "REEMBOLSO DE V.T",
];

const ModalNovoLancamento = ({ centrosCustoOpts = [], onLancamentoCreated }) => {

    const { closeModal } = useModal();
    const api = useApi();

    const [saving, setSaving] = useState(false);
    const [loadingNome, setLoadingNome] = useState(false);
    const [colaborador, setColaborador] = useState("");

    const [formValues, setFormValues] = useState({
        obra: "",
        motivo: "",
        matricula: "",
        valor: 0,
        data: "",
        observacoes: "",
    });

    const handleChange = (e) => {

        const { name, value } = e.target;

        setFormValues((prev) => {

            if (name === "valor") {
                return { ...prev, valor: parseCentsFromInput(value) };
            }

            if (name === "matricula") {
                const onlyDigits = String(value || "").replace(/\D/g, "").slice(0, 6);
                return { ...prev, matricula: onlyDigits };
            }

            if (name === "observacoes") {
                return { ...prev, observacoes: value };
            }

            return { ...prev, [name]: value };

        });

    }

    /* Busca automática do nome do colaborador quando a matrícula tem 6 dígitos.
       Mesma regra da tela antiga (OverlayPagamento). */
    useEffect(() => {

        if (formValues.matricula.length !== 6) {
            setColaborador("");
            return;
        }

        let cancelled = false;

        const fetchNome = async () => {

            setLoadingNome(true);
            setColaborador("CARREGANDO...");

            try {

                const { data } = await api.post("/Painel/API/GetColabName/", {
                    matricula: formValues.matricula,
                });

                if (cancelled) return;

                if (data?.STATUS === "SUCCESS") {
                    setColaborador(data.NOME || "");
                } else {
                    setColaborador("COLABORADOR NÃO ENCONTRADO");
                }

            } catch (e) {

                if (cancelled) return;
                console.error(e);
                setColaborador("ERRO AO BUSCAR COLABORADOR");

            } finally {

                if (!cancelled) setLoadingNome(false);

            }

        }

        fetchNome();

        return () => {
            cancelled = true;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formValues.matricula]);

    const handleSubmit = async (e) => {

        e.preventDefault();

        if (!formValues.obra) {
            alert("Selecione o centro de custo.");
            return;
        }
        if (!formValues.motivo) {
            alert("Selecione o motivo.");
            return;
        }
        if (formValues.matricula.length !== 6) {
            alert("Informe uma matrícula de 6 dígitos.");
            return;
        }
        if (!formValues.valor || formValues.valor === 0) {
            alert("Informe o valor.");
            return;
        }
        if (!formValues.data) {
            alert("Informe a data.");
            return;
        }

        try {

            setSaving(true);

            const payload = {
                obra: formValues.obra,
                motivo: formValues.motivo,
                matricula: formValues.matricula,
                valor: formValues.valor / 100,
                data: formValues.data,
                observacoes: formValues.observacoes || null,
            };

            await api.post("/Painel/API/FolhaPag/Lancamentos/", payload);

            closeModal();

            if (onLancamentoCreated) {
                onLancamentoCreated();
            }

        } catch (err) {

            console.error(err);
            alert("Erro ao salvar lançamento.");

        } finally {

            setSaving(false);

        }

    }

    return (
        <Overlay state={ true } >
            <Modal header close={ closeModal } >
                <Formulario onSubmit={ handleSubmit } >
                    <FormComp
                        title="CENTRO DE CUSTO"
                        type="select"
                        options={ centrosCustoOpts }
                        valor={ formValues.obra }
                        name="obra"
                        changeFunc={ handleChange }
                        required
                    />
                    <FormComp
                        title="MOTIVO"
                        type="select"
                        options={ MOTIVOS }
                        valor={ formValues.motivo }
                        name="motivo"
                        changeFunc={ handleChange }
                        required
                    />
                    <FormComp
                        title="MATRÍCULA"
                        type="text"
                        inputMode="numeric"
                        maxLength={ 6 }
                        placeholder="EX: 001234"
                        valor={ formValues.matricula }
                        name="matricula"
                        changeFunc={ handleChange }
                        required
                    />
                    <FormComp
                        title="COLABORADOR"
                        type="text"
                        readOnly
                        valor={ loadingNome ? "CARREGANDO..." : colaborador }
                    />
                    <FormComp
                        title="VALOR"
                        type="text"
                        inputMode="numeric"
                        placeholder="R$ 0,00"
                        valor={ formatBRLFromCents(formValues.valor) }
                        name="valor"
                        changeFunc={ handleChange }
                        required
                    />
                    <FormComp
                        title="DATA"
                        type="date"
                        valor={ formValues.data }
                        name="data"
                        changeFunc={ handleChange }
                        required
                    />
                    <FormComp
                        title="OBSERVAÇÕES"
                        type="textarea"
                        valor={ formValues.observacoes }
                        name="observacoes"
                        changeFunc={ handleChange }
                    />
                    <FormComp
                        type="submit"
                        valor={ saving ? "SALVANDO..." : "SALVAR" }
                        disabled={ saving }
                    />
                </Formulario>
            </Modal>
        </Overlay>
    )

}

export default ModalNovoLancamento;
